import React from 'react';
import GPSFluxBlock from './GPSFluxBlock';
import GPSStockBlock from './GPSStockBlock';

/**
 * Composes the KPI blocks according to the global "Afficher" sense:
 *  - all       → Flux + Encours blocks side by side
 *  - received  → focused Flux block (received)
 *  - resolved  → focused Flux block (resolved)
 *  - ongoing   → Encours block only
 * A flux never shows stock and vice-versa.
 */
const GPSKpiSection = ({ sense, stats }) => {
  if (sense === 'received') {
    return <GPSFluxBlock stats={stats} mode="received" />;
  }
  if (sense === 'resolved') {
    return <GPSFluxBlock stats={stats} mode="resolved" />;
  }
  if (sense === 'ongoing') {
    return <GPSStockBlock stats={stats} fullWidth />;
  }
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 items-stretch">
      <GPSFluxBlock stats={stats} mode="all" />
      <GPSStockBlock stats={stats} />
    </div>
  );
};

export default GPSKpiSection;
